export function ToMillimeters(l: number) {
  return l ? l / 100 : 0;
}
